import { Asterisk } from "@phosphor-icons/react";
import { marqueeWords } from "../content";

function Row({ hidden }: { hidden?: boolean }) {
  return (
    <ul aria-hidden={hidden} className="flex shrink-0 items-center">
      {marqueeWords.map((word, i) => (
        <li key={word} className="flex items-center">
          <span
            className={`px-6 font-display text-4xl font-extrabold uppercase tracking-tighter md:px-12 md:text-7xl ${
              i % 2 ? "text-outline" : ""
            }`}
          >
            {word}
          </span>
          <Asterisk weight="light" className="h-6 w-6 text-stab md:h-12 md:w-12" />
        </li>
      ))}
    </ul>
  );
}

export function Marquee() {
  return (
    <section aria-label="What Miss Stabbypants makes" className="overflow-hidden border-y border-white/10 py-5 md:py-8">
      <div className="flex w-max animate-marquee">
        <Row />
        <Row hidden />
      </div>
    </section>
  );
}
